// OverlayDirtyTracker — „nicht gespeichert"-Zustand pro Zeile, ABGELEITET aus dem Vergleich
// GESPEICHERTER Snapshot (Baseline) vs. aktuelle DOM-Feldwerte. „dirty" = weicht vom gespeicherten Stand
// ab (nicht „wurde angefasst"): erreicht ein Feld wieder seinen alten Wert, wird die Zeile ohne Speichern
// wieder clean. Besitzt die Baselines (savedState).
//
// Liest/schreibt das DOM noch direkt (jQuery, window.$) — wird mit der State-Konsolidierung (Schnitt 4)
// auf den State umgestellt. Kein AJAX, keine Karte. Markiert pro Feld (.fieldDirty), pro Zeile (.dirty)
// und spiegelt den Gesamtzähler (#unsavedCount / #saveall).

import { str } from "../i18n/str.js";

export function createOverlayDirtyTracker() {
    const $ = window.$;
    const savedState = {};   // ref → letzter gespeicherter Snapshot

    function snapshotOf(id) {
        return {
            name: $('#name' + id).val(), year: $('#year' + id).val(), info_text: $('#infoText' + id).val(),
            zoom: $('#zoom' + id).val(),
            sw: $('#inpSW' + id).val(), ne: $('#inpNE' + id).val(),
            distort: $('#inpDistort' + id).val(), rotation: $('#rotation' + id).val()
        };
    }

    function setFieldDirty(sel, on) { $(sel).toggleClass('fieldDirty', !!on); }   // rosa bg pro geändertem Feld

    // Globaler Zähler — sitzt IM „alle speichern"-Button (Σ + Diskette + Anzahl). Quelle = dirty-Zeilen.
    function updateUnsavedCount() {
        var n = $('#overlayDataContainer .overlayRow.dirty').length;
        $('#unsavedCount').text(n);
        $('#saveall').prop('disabled', n === 0)
            .attr('title', n === 0 ? str('OVERLAY_ALL_SAVED') : topo.tpl(str('OVERLAY_SAVE_ALL_COUNT'), { count: n }));
    }

    function markDirty(id) { $('#tr' + id).addClass('dirty'); updateUnsavedCount(); }
    function markClean(id) { $('#tr' + id).removeClass('dirty'); updateUnsavedCount(); }

    function recompute(id) {
        var s = savedState[id];
        if (!s) { markDirty(id); return; }   // kein Baseline (z.B. frisch platziert) → konservativ dirty
        var c = snapshotOf(id);
        // Pro Feld markieren, damit sichtbar ist WAS abweicht. Georef: die zwei sichtbaren Boxen je Ecke folgen sw/ne.
        setFieldDirty('#name' + id, c.name !== s.name);
        setFieldDirty('#year' + id, c.year !== s.year);
        setFieldDirty('#infoText' + id, c.info_text !== s.info_text);
        setFieldDirty('#zoom' + id, c.zoom !== s.zoom);
        setFieldDirty('#rotation' + id, c.rotation !== s.rotation);
        var swDirty = c.sw !== s.sw, neDirty = c.ne !== s.ne;
        setFieldDirty('#geoLatSW' + id, swDirty); setFieldDirty('#geoLngSW' + id, swDirty);
        setFieldDirty('#geoLatNE' + id, neDirty); setFieldDirty('#geoLngNE' + id, neDirty);
        var clean = c.name === s.name && c.year === s.year && c.info_text === s.info_text && c.zoom === s.zoom
            && c.sw === s.sw && c.ne === s.ne && c.distort === s.distort && c.rotation === s.rotation;
        if (clean) { markClean(id); } else { markDirty(id); }
    }

    // Baseline einer Zeile als gespeicherten Stand erfassen (nach Render+Editor-Init bzw. nach erfolgreichem Save).
    function captureBaseline(id) { savedState[id] = snapshotOf(id); }
    function captureAllBaselines() {
        $('#overlayDataContainer .overlayRow').each(function () {
            var rid = $(this).attr('data-id');
            savedState[rid] = snapshotOf(rid);
        });
    }

    // Baseline-Snapshot mit der Zeile umschlüsseln (m->o-Migration).
    function rekey(oldRef, newRef) {
        if (savedState[oldRef] !== undefined) { savedState[newRef] = savedState[oldRef]; delete savedState[oldRef]; }
    }

    return { recompute, markClean, captureBaseline, captureAllBaselines, rekey };
}
